import React from 'react'
import { FunctionField, useTranslate, useRecordContext } from 'react-admin'
import { isStatus } from 'src/components/pages/sales/reservation/helper/isStatus'
import { CircularProgress } from '@mui/material'
interface Props {
  source: string
  label: string
  serviceQr: any
  getValue: Function,
  translateValue: Function
}

export const FormattedTextFieldWithStatus: React.FC<React.PropsWithChildren<Props>> = ({
  source,
  label,
  serviceQr,
  getValue,
  translateValue
}) => {
  const record = useRecordContext()
  const translate = useTranslate()
  serviceQr && serviceQr(record)
  const isLoading = record && Object.keys(record).length === 1 // if "record" JUST only "product" key(this always exist), then is Loading

  const getValueAux = () => {
    let value = record?.[source] ? record?.[source] : source === 'payment_status' ? 'UNPAID' : null // UNPAID status is by payment_status

    if (getValue) {
      value = getValue(value)
    }

    return value
  }

  const FuctionFieldAux = () => {
    const value = getValueAux()
    const translateAux = translateValue ? translateValue(value) : true

    return <FunctionField
      label={label}
      render={() => !translateAux || translate(`ra.status.${value}`).includes('.')
        ? value
        : translate(`ra.status.${value}`)
      }
      style={value && { ...isStatus(label, value, true) }}
    />
  }

  return (
    <>
      {isLoading ? (
        <CircularProgress size={'10px'} />
      ) : (
        <FuctionFieldAux />
      )}
    </>
  )
}
